import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const { isAuthenticated, sendPasswordReset, isFirebaseConfigured } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  if (isAuthenticated) return <Navigate to="/" replace />;

  if (sent) {
    return (
      <div className="form-shell">
        <div className="form-card" style={{ textAlign: 'center' }}>
          <div className="mb-6 h-1.5 w-16 rounded-full bg-gradient-to-r from-indigo-500 to-violet-500" style={{ margin: '0 auto 24px' }} />
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg style={{ width: 28, height: 28, color: '#6366F1' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
              </svg>
            </div>
          </div>
          <h1 className="page-title">{t('auth.resetLinkSentTitle')}</h1>
          <p className="page-subtitle" style={{ marginTop: 8 }}>
            {t('auth.resetLinkSentDesc', { email })}
          </p>
          <Link
            to="/login"
            className="btn btn-primary"
            style={{ display: 'block', width: '100%', marginTop: 24, textAlign: 'center' }}
          >
            {t('auth.backToSignIn')}
          </Link>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await sendPasswordReset(email);
    setLoading(false);
    if (!result.ok) { setError(result.message); return; }
    setSent(true);
  };

  return (
    <div className="form-shell">
      <div className="form-card">
        <div className="mb-6 h-1.5 w-16 rounded-full bg-gradient-to-r from-indigo-500 to-violet-500" />

        <h1 className="page-title section-gap">{t('auth.resetPassword')}</h1>
        <p className="page-subtitle">{t('auth.resetPasswordDesc')}</p>

        <form className="section-gap" onSubmit={handleSubmit}>
          <div className="form-row">
            <label htmlFor="email">{t('auth.email')}</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
              autoComplete="email"
              placeholder={t('auth.emailPlaceholder')}
              required
            />
          </div>

          {error && (
            <div className="error-box">
              <svg className="h-4 w-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
              {error}
            </div>
          )}

          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading || !isFirebaseConfigured}>
            {loading ? t('auth.sendingResetLink') : t('auth.sendResetLink')}
          </button>

          {!isFirebaseConfigured && (
            <p className="social-note">{t('auth.firebaseNotConfiguredPasswordReset')}</p>
          )}
        </form>

        <p className="muted-link-row">
          <Link to="/login">{t('auth.backToSignIn')}</Link>
        </p>
      </div>
    </div>
  );
}
